import React, { useEffect, useRef } from 'react';
import styles from '../styles/Footer.module.css';

const HUBSPOT_PORTAL_ID = '5688825';
const HUBSPOT_FORM_ID = '6d6faf1a-641d-41e6-8dab-953486d493d8';

export default function Footer() {
    const formTargetRef = useRef(null);

    useEffect(() => {
        const createForm = () => {
            if (window.hbspt && formTargetRef.current) {
                formTargetRef.current.innerHTML = '';

                window.hbspt.forms.create({
                    portalId: HUBSPOT_PORTAL_ID,
                    formId: HUBSPOT_FORM_ID,
                    region: 'na1',
                    target: `#${formTargetRef.current.id}`,
                });
            }
        };

        if (window.hbspt) {
            createForm();
            return undefined;
        }

        const existingScript = document.querySelector(
            'script[src="//js.hsforms.net/forms/embed/v2.js"]'
        );

        if (existingScript) {
            existingScript.addEventListener('load', createForm);

            return () => {
                existingScript.removeEventListener('load', createForm);
            };
        }

        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.addEventListener('load', createForm);
        document.body.appendChild(script);

        return () => {
            script.removeEventListener('load', createForm);
        };
    }, []);

    return (
        <footer className={styles.footer}>
            <div className={styles.footerInner}>
                <div className={styles.footerIndex} aria-hidden="true">
                    <span>Footer</span>
                </div>

                <div className={styles.footerMain}>
                    <section className={styles.footerSubscribe}>
                        <div className={styles.footerSubscribeText}>
                            <h3 className={styles.footerSubscribeTitle}>
                                Subscribe to our newsletter
                            </h3>

                            <p className={styles.footerSubscribeDesc}>
                                Receive insights, updates, and practical tips
                                for your next creative project.
                            </p>
                        </div>

                        <div className={styles.footerSubscribeForm}>

                            <div
                                id="hubspot-newsletter-form"
                                ref={formTargetRef}
                            />
                        </div>
                    </section>

                    <div className={styles.footerContent}>
                        <div
                            className={`${styles.footerCell} ${styles.footerStudioCell}`}
                        >
                            <a href="/" className={styles.footerMark}>
                                MESHAE STUDIOS
                            </a>

                            <p className={styles.footerDesc}>
                                Make your complicated projects simple.
                            </p>
                        </div>

                        <div className={styles.footerCell}>
                            <p className={styles.footerLabel}>Follow</p>

                            <a
                                href="https://www.youtube.com/@meshaestudios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.footerMetaLink}
                            >
                                YouTube
                            </a>

                            <a
                                href="https://vimeo.com/meshaestudios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.footerMetaLink}
                            >
                                Vimeo
                            </a>

                            <a
                                href="https://instagram.com/meshae_studios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.footerMetaLink}
                            >
                                Instagram
                            </a>

                            <a
                                href="https://www.facebook.com/profile.php?id=61584826494736"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.footerMetaLink}
                            >
                                Facebook
                            </a>
                        </div>

                        <div className={styles.footerCell}>
                            <p className={styles.footerLabel}>Work</p>

                            <a
                                href="/designlab"
                                className={styles.footerMetaLink}
                            >
                                Design Lab
                            </a>

                            <a
                                href="/storylab"
                                className={styles.footerMetaLink}
                            >
                                Story Lab
                            </a>
                        </div>

                        <div className={styles.footerCell}>
                            <p className={styles.footerLabel}>Contact</p>

                            <a
                                href="/contact"
                                className={styles.footerMetaLink}
                            >
                                General Inquiries
                            </a>

                            <a
                                href="/new-client"
                                className={styles.footerMetaLink}
                            >
                                Start a Project
                            </a>
                        </div>

                        <div className={styles.footerCell}>
                            <p className={styles.footerLabel}>Legal</p>

                            <a
                                href="/privacy-policy"
                                className={styles.footerMetaLink}
                            >
                                Privacy Policy
                            </a>

                            <a
                                href="/terms-of-service"
                                className={styles.footerMetaLink}
                            >
                                Terms of Service
                            </a>
                        </div>
                    </div>
                    <div className={styles.footerBottomRule}>
                        <span className={styles.footerMeta}>
                            © 2026 Meshae Studios LLC
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}